import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { TrendUp, ArrowClockwise, FireSimple } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function SnapSurge() {
  const [data, setData] = useState({ alerts: [], generated_at: null });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.snapSurgeGet();
        setData(r);
      } catch (e) {}
    })();
  }, []);

  const refresh = async () => {
    setLoading(true);
    try {
      const r = await api.snapSurgeRefresh();
      setData(r);
      toast.success(`Snap Surge: ${r.count} breakout alert${r.count !== 1 ? "s" : ""}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Snap surge fetch failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#121212] border border-zinc-800">
      <div className="px-4 py-3 border-b border-zinc-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FireSimple size={16} className="text-[#E11D2E]" weight="fill" />
          <div className="heading font-bold">Snap Surge Breakout Radar</div>
          <span className="overline">10%+ WoW snap share jumps</span>
        </div>
        <button onClick={refresh} disabled={loading}
          className="p-2 border border-zinc-800 hover:border-zinc-600 text-zinc-400 disabled:opacity-40">
          <ArrowClockwise size={14} className={loading ? "animate-spin" : ""} />
        </button>
      </div>
      {data.alerts?.length === 0 ? (
        <div className="p-6 text-sm text-zinc-500 text-center">
          No breakout alerts yet. Snap Surge scans the previous week's play-by-play for players who spiked in snap share, so it stays quiet until Week 1 games have been played.
        </div>
      ) : (
        <div className="max-h-[280px] overflow-y-auto">
          <table className="w-full text-xs mono">
            <thead className="bg-black sticky top-0">
              <tr className="text-left text-zinc-400 uppercase tracking-widest text-[10px]">
                <th className="px-3 py-2">Player</th>
                <th className="px-3 py-2">Pos</th>
                <th className="px-3 py-2">Tm</th>
                <th className="px-3 py-2">Prior</th>
                <th className="px-3 py-2">Current</th>
                <th className="px-3 py-2">Δ</th>
                <th className="px-3 py-2">Wk</th>
              </tr>
            </thead>
            <tbody>
              {data.alerts.map((a) => (
                <tr key={`${a.player}-${a.team}-${a.week}`} className="border-t border-zinc-900">
                  <td className="px-3 py-2 font-medium">{a.player}</td>
                  <td className="px-3 py-2 text-zinc-500">{a.position}</td>
                  <td className="px-3 py-2 text-zinc-500">{a.team}</td>
                  <td className="px-3 py-2 text-zinc-500">{a.prior_snap_pct}%</td>
                  <td className="px-3 py-2">{a.current_snap_pct}%</td>
                  <td className="px-3 py-2 text-[#39FF14] font-bold">+{a.delta}%</td>
                  <td className="px-3 py-2 text-zinc-500">W{a.week}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data.generated_at && (
        <div className="px-4 py-2 border-t border-zinc-900 text-[10px] mono text-zinc-500 text-right">
          Last scan: {new Date(data.generated_at).toLocaleString()}
        </div>
      )}
    </section>
  );
}
